import React from 'react';
import CompassEnterpriseImage from './compass-enterprise-image';

import './notify-images.css';

export default function MonitorImages() {
  return (
    <div className="notify-images-grid">
      <CompassEnterpriseImage className="notify-only-image" />
    </div>
  );
}
